// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".drawers{align-items:stretch;display:flex;flex:1;flex-wrap:nowrap;min-height:100%;padding-right:calc(var(--x-gutter) + var(--x-gutter-sm));position:relative;transform-style:preserve-3d}.drawers.is-right{justify-content:flex-end;padding-left:calc(var(--x-gutter) + var(--x-gutter-sm));padding-right:0}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
module.exports = ___CSS_LOADER_EXPORT___;
